export default "__VITE_ASSET__CGlZ5MY0__"